const contactItems = [
  {
    icon: "ri-map-pin-2-line",
    label: "Address",
    lines: ["1 General Gurko", "Ruse 7012", "Bulgaria"],
  },
  {
    icon: "ri-mail-line",
    label: "Email",
    lines: ["help@tiasood.com"],
  },
  {
    icon: "ri-phone-line",
    label: "Phone",
    lines: ["+1 318 712 9928"],
  },
];

export default function ContactSection() {
  return (
    <section id="contact" className="w-full py-28 bg-[#F8F6F2]">
      <div className="max-w-7xl mx-auto px-6 lg:px-12">
        <div className="grid lg:grid-cols-2 gap-16 items-start">
          {/* Left: text */}
          <div>
            <span className="text-amber-600 text-xs font-semibold uppercase tracking-widest">Get In Touch</span>
            <h2 className="mt-3 text-4xl lg:text-5xl font-bold text-gray-900 leading-tight">
              We're Here <br />to Help
            </h2>
            <p className="mt-6 text-gray-600 text-base leading-relaxed max-w-md">
              Have questions about our products, need support, or want to learn
              more about TIAS OOD? Reach out to our team — we're always happy to
              assist.
            </p>

            {/* Decorative image */}
            <div className="mt-10 rounded-2xl overflow-hidden w-full h-52">
              <img
                src="https://public.readdy.ai/ai/img_res/70082a1a41465dabe27d07f7f6e2db9b.jpg"
                alt="Ruse, Bulgaria"
                className="w-full h-full object-cover object-top"
              />
            </div>
          </div>

          {/* Right: contact details */}
          <div className="flex flex-col gap-5">
            {contactItems.map((item) => (
              <div
                key={item.label}
                className="bg-white rounded-2xl px-8 py-7 flex items-start gap-5 border border-gray-100"
              >
                <div className="w-11 h-11 flex items-center justify-center bg-amber-50 rounded-xl flex-shrink-0">
                  <i className={`${item.icon} text-amber-600 text-lg`} />
                </div>
                <div>
                  <p className="text-xs font-semibold uppercase tracking-widest text-gray-400 mb-2">
                    {item.label}
                  </p>
                  {item.lines.map((line) => (
                    <p key={line} className="text-gray-800 font-medium text-base leading-snug">
                      {line}
                    </p>
                  ))}
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>

      {/* Footer bar */}
      <div className="mt-20 border-t border-gray-200">
        <div className="max-w-7xl mx-auto px-6 lg:px-12 pt-8 flex flex-col sm:flex-row items-center justify-between gap-4">
          <div className="flex items-center gap-3">
            <img
              src="https://public.readdy.ai/ai/img_res/ee23ca22-bf02-46a8-907b-9d269ae080a1.png"
              alt="TIAS OOD Logo"
              className="w-8 h-8 object-contain"
            />
            <span className="text-sm font-semibold text-gray-700">TIAS OOD</span>
          </div>
          <p className="text-sm text-gray-400">
            &copy; {new Date().getFullYear()} TIAS OOD. All rights reserved.
          </p>
          <p className="text-sm text-gray-400">iOS Application Development</p>
        </div>
      </div>
    </section>
  );
}
